import { Dimensions, Keyboard, Linking, Platform, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedText, ThemedView } from '@app/theme'
import WebView, { WebViewNavigation } from 'react-native-webview'
import { UPI_IDENTIFIERS } from '@app/configs/constants'

const MandateModal = ({ mandateModalData , executeCheck }: {
    mandateModalData: any
    executeCheck : (params : any) => void
}) => {


    function onNavigationStateChanged(webViewState: WebViewNavigation) {
        var regex = /[?&]([^=#]+)=([^&#]*)/g,
            params = {},
            match;
        while (match = regex.exec(webViewState.url)) {
            params[match[1]] = match[2];
        }
        executeCheck(params)
    }

    const onShouldStartLoadWithRequest = (event: any) => {
		const { url } = event;
        let finalUrl = url;
        if (url.startsWith("intent:")) {
            const match = url.match(/intent:(.*)#Intent/);
            if (match && match[1]) {
                finalUrl = match[1];
                console.log("Extracted UPI URL:", finalUrl);
            }
        }
        if (finalUrl.startsWith("upi://") || UPI_IDENTIFIERS.some(identifier => finalUrl.includes(identifier))) {
            try {
                Linking.canOpenURL(finalUrl).then((supported) => {
                    if (supported) {
                        Linking.openURL(finalUrl);
                        Keyboard.dismiss();
                    }
                });
            } catch (error) {
                console.error('Error opening start UPI link:');
            }
            return false;
            } else {
                return true
        }
    };

    return (
        <ThemedView pt='lg' borderTopLeftRadius='lg' borderTopRightRadius='lg' overflow='hidden' minHeight={Platform.OS === 'android' ? '100%' : Dimensions.get('screen').height - 100}>
            <WebView style={{ flex: 1 }} source={{ uri: mandateModalData?.webUrl }}
                javaScriptEnabled={true}
                domStorageEnabled={true}
                onNavigationStateChange={(event) => onNavigationStateChanged(event)}
                onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
                originWhitelist={['*']}
                automaticallyAdjustContentInsets={false}
                useWebKit={true}
                allowsInlineMediaPlayback
                mediaPlaybackRequiresUserAction={false}
                javaScriptEnabledAndroid
                showsHorizontalScrollIndicator={false}
                nestedScrollEnabled={Platform.OS !== "web"}
                scalesPageToFit={false}
                scrollEnabled={Platform.OS === "ios"}
                injectedJavaScript={`
                   $('form:first').css('max-width', '100%');
                   $('form:first').css('width', '100%');
                   $('div:first').removeClass("wrapper");
                   $('form:first').css('position', 'unset');
                   $('form:first').css('padding-bottom', '100%');
                   $('body').scrollTop({0});`
                }
            />
        </ThemedView>
    )
}

export default MandateModal

const styles = StyleSheet.create({})